// extracted by mini-css-extract-plugin
export default {"failed":"_5DZKxnhZ","message":"_5DYZDnv8","retry":"_5DnUwRLb"};